export default function getTimeStr(date = new Date()) {
  const hrStr = date.getHours().toString().padStart(2, "0");
  const minStr = date.getMinutes().toString().padStart(2, "0");
  return `${hrStr}:${minStr}`;
}
